import React, { useContext, useState } from "react";
import { Modal, Tooltip, Dropdown } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { VoiceCommandContext } from "../Pages/VoiceCommand/VoiceContext";
import { useDispatch, useSelector } from "react-redux";
import {
  SHOWALERTTRUE,
  SHOWALERTFALSE,
  SET_ROUTE,
} from "../../Redux/actions/CommonActions";
import { db } from "../../config/firebase";
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import {
  clearLoggedUser,
  clearSelectedAppt,
} from "../../Redux/actions/UserActions";
import { deleteCallRecord } from "../../config/firebase";
import doxzonlogo from "../../Assets/logo/DoxzonLogoWhitebackground.svg";
import {
  LayoutGrid,
  CalendarDays,
  BarChart3,
  Clock,
  Users,
  HeartPulse,
  Bed,
  Wallet,
  FileText,
  FileBarChart,
  Share2,
  SlidersHorizontal,
  Hospital,
  Lock,
  LogOut,
  ChevronsLeft,
  ChevronsRight,
  ChevronDown,
  Activity,
  Laptop,
} from "lucide-react";
import { FaClipboardList } from "react-icons/fa";

const DoxzonClover = ({ className = "w-7 h-7" }) => (
  <svg
    viewBox="165 10 145 140"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M231.183 118.673L213.041 135.513C202.661 145.147 186.223 143.673 177.722 132.347V132.347C170.845 123.182 171.452 110.423 179.169 101.953L191.017 88.9483C195.741 83.7642 196.398 76.056 192.621 70.1469L181.024 52.0032C174.793 42.2541 176.525 29.4286 185.119 21.6816V21.6816C194.95 12.8198 210.138 13.7437 218.822 23.7318L219.614 24.6427L236.253 43.0089L260.361 67.9992C266.734 74.6058 266.252 85.2093 259.306 91.2106L243.989 104.444"
      stroke="#0AA0AC"
      strokeWidth="11"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M245.414 38.2834L263.571 22.3437C273.834 13.3337 289.512 14.5836 298.218 25.1058V25.1058C305.911 34.4033 305.588 47.9447 297.461 56.8648L286.48 68.9171C281.756 74.1012 281.099 81.8094 284.876 87.7185L296.836 106.43C302.88 115.886 301.299 128.311 293.08 135.952V135.952C284.678 143.763 271.834 144.271 262.841 137.15L257.883 133.223L241.245 114.856L215.119 87.9871C208.991 81.6851 209.319 71.5557 215.842 65.6631L231.185 51.8012"
      stroke="#004B73"
      strokeWidth="11"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M223.729 60.1992V64.8285H237.617L241.089 62.5139L237.617 60.1992H223.729Z"
      fill="#004B73"
    />
    <path
      d="M237.618 60.1992H254.978V64.8285H237.618L241.09 62.5139L237.618 60.1992Z"
      fill="#0AA0AC"
    />
    <path
      d="M212.172 80.5234V85.1528H237.633L241.105 82.8381L237.633 80.5234H212.172Z"
      fill="#004B73"
    />
    <path
      d="M237.646 80.5234H264.264V85.1528H237.646L241.118 82.8381L237.646 80.5234Z"
      fill="#0AA0AC"
    />
    <path
      d="M223.729 92.0918V96.7211H239.932V92.0918H236.692H223.729Z"
      fill="#004B73"
    />
    <path
      d="M239.944 92.074C238.666 92.074 237.63 93.1103 237.63 94.3887C237.63 95.667 238.666 96.7033 239.944 96.7033V92.074ZM239.944 94.3887V96.7033H256.147V94.3887V92.074H239.944V94.3887Z"
      fill="#0AA0AC"
    />
    <path
      d="M212.172 70.3457V74.975H239.948V70.3457H234.393H212.172Z"
      fill="#004B73"
    />
    <path
      d="M239.949 70.324C238.671 70.324 237.635 71.3603 237.635 72.6387C237.635 73.917 238.671 74.9533 239.949 74.9533V70.324ZM239.949 72.6387V74.9533H263.096V72.6387V70.324H239.949V72.6387Z"
      fill="#0AA0AC"
    />
  </svg>
);

function Sidemenu({ isMenuOpen: propIsMenuOpen, handleSideBarMenu }) {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isMenuOpen =
    propIsMenuOpen !== undefined ? propIsMenuOpen : internalIsOpen;

  const openSidebar = (e) => {
    if (e) e.stopPropagation();
    if (handleSideBarMenu) {
      handleSideBarMenu();
    } else {
      setInternalIsOpen(true);
    }
  };

  const closeSidebar = (e) => {
    if (e) e.stopPropagation();
    if (handleSideBarMenu) {
      handleSideBarMenu();
    } else {
      setInternalIsOpen(false);
    }
  };

  const { isListening, setIsListening } = useContext(VoiceCommandContext) || {};
  const { alert, route } = useSelector((state) => state.common || {});
  const location = useLocation();
  const history = useHistory();
  const [pageRoute, setPageRoute] = useState("");
  const [LogoutWarning, setLogOutWarning] = useState(false);
  const [isRpmSubMenuOpen, setIsRpmSubMenuOpen] = useState(false);

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const dispatch = useDispatch();
  const { selectedAppt, loggedUser } = useSelector((state) => state.user || {});

  const handleCancel = () => {
    dispatch({ type: SHOWALERTFALSE });
    dispatch({ type: SET_ROUTE, payload: "" });
  };

  const isMenuItemActive = (path) => {
    if (!path) return false;
    if (location.pathname === path) return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleNavigation = (path) => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(path);
      if (setIsListening) setIsListening(false);
      dispatch({ type: SHOWALERTTRUE });
      dispatch({ type: SET_ROUTE, payload: path });
    } else if (path === APP_ROUTES.LOGINFORM) {
      sessionStorage.clear();
      setPageRoute("");
      history.push(path);
    } else {
      setPageRoute("");
      history.push(path);
    }
  };

  const handleLogout = (path) => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(path);
      dispatch({ type: SHOWALERTTRUE });
      dispatch({ type: SET_ROUTE, payload: path });
    } else {
      setLogOutWarning(true);
      setPageRoute(path);
      dispatch({ type: SET_ROUTE, payload: path });
    }
  };

  const handleLogOutOk = () => {
    sessionStorage.clear();
    dispatch({ type: SHOWALERTFALSE });
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    history.push(route || APP_ROUTES.LOGINFORM);
  };

  const handleLogOutCancel = () => {
    setLogOutWarning(false);
    dispatch({ type: SET_ROUTE, payload: "" });
  };

  const onLeave = async () => {
    dispatch({ type: SHOWALERTFALSE });

    const appointmentId = selectedAppt?.appointmentId;
    const doctorUserId = loggedUser?.user?.userId;

    // Safe delete — only removes if this doctor was the original caller
    await deleteCallRecord(appointmentId, doctorUserId);

    sessionStorage.removeItem("selectedAppt");
    sessionStorage.removeItem("callRoomId");
    dispatch(clearSelectedAppt(null));

    if (route === APP_ROUTES.LOGINFORM) {
      dispatch(clearLoggedUser(null));
      sessionStorage.clear();
    }
    history.push(route);
  };

  const deleteFirebaseCall = async (roomId) => {
    try {
      const callRef = doc(db, "calls", roomId);
      const snap = await getDoc(callRef);

      if (!snap.exists()) return;

      const callData = snap.data();
      const callerId = callData?.incomingCall?.callerId;

      if (callerId !== loggedUser?.user?.userId) {
        console.warn("Non-caller attempted to delete call. Ignored.");
        return;
      }

      await deleteDoc(callRef);
    } catch (err) {
      console.error("Error deleting Firebase call:", err);
    }
  };

  // RPM Sub-items
  const rpmSubItems = [
    {
      label: "RPM Dashboard",
      route: APP_ROUTES.RPMDASHBOARD,
      icon: LayoutGrid,
    },
    {
      label: "Vital Parameters",
      route: APP_ROUTES.RPMVITALPARAMS,
      icon: Activity,
    },
    {
      label: "Task/Frequency",
      route: APP_ROUTES.RPMTASKFREQUENCY,
      icon: FaClipboardList,
    },
    {
      label: "Device setup",
      route: APP_ROUTES.DEVICESETUP,
      icon: Laptop,
    },
    {
      label: "Activity Report",
      route: APP_ROUTES.RPMACTIVITYREPORT,
      icon: BarChart3,
    },
  ];

  const isRpmActive =
    isMenuItemActive(APP_ROUTES.RPMDASHBOARD) ||
    isMenuItemActive(APP_ROUTES.RPMVITALPARAMS) ||
    isMenuItemActive(APP_ROUTES.RPMTASKFREQUENCY) ||
    isMenuItemActive(APP_ROUTES.DEVICESETUP) ||
    isMenuItemActive(APP_ROUTES.RPMACTIVITYREPORT);

  // Dropdown items for RPM when collapsed
  const rpmDropdownItems = rpmSubItems.map((subItem) => ({
    key: subItem.route,
    label: (
      <div
        onClick={() => handleNavigation(subItem.route)}
        className="flex items-center gap-2 py-1 px-1 font-medium text-sm text-[#334155] hover:text-[#0E8378]"
      >
        <subItem.icon className="w-4 h-4 text-[#0E8378]" />
        <span>{subItem.label}</span>
      </div>
    ),
  }));

  // Master menu items list corresponding to the design
  const navItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: LayoutGrid,
      route: APP_ROUTES.DASHBOARD,
      isActive:
        isMenuItemActive(APP_ROUTES.DASHBOARD) ||
        isMenuItemActive(APP_ROUTES.NEWDASHBOARD),
      show: true,
    },
    {
      key: "appointments",
      label: "Appointments",
      icon: CalendarDays,
      route: APP_ROUTES.APPOINTMENTS,
      isActive:
        isMenuItemActive(APP_ROUTES.APPOINTMENTS) ||
        isMenuItemActive(APP_ROUTES.APPTCALENDAR) ||
        isMenuItemActive(APP_ROUTES.REQUESTAPPOINTMENTS),
      show: true,
    },
    {
      key: "analytics",
      label: "Analytics",
      icon: BarChart3,
      route: APP_ROUTES.ANALYTICS,
      isActive: isMenuItemActive(APP_ROUTES.ANALYTICS),
      show:
        !loginResultObject || loginResultObject?.user?.himsApplicable === "Y",
    },
    {
      key: "slot",
      label: "Slot",
      icon: Clock,
      route: APP_ROUTES.SLOT,
      isActive: isMenuItemActive(APP_ROUTES.SLOT),
      show: true,
    },
    {
      key: "patients",
      label: "Patients",
      icon: Users,
      route: APP_ROUTES.PATIENTS,
      isActive:
        isMenuItemActive(APP_ROUTES.PATIENTS) ||
        isMenuItemActive(APP_ROUTES.PATIENTLIST),
      show: true,
    },
    {
      key: "rpm",
      label: "RPM",
      icon: HeartPulse,
      isRpm: true,
      isActive: isRpmActive,
      show:
        !loginResultObject || loginResultObject?.user?.rpmApplicable === "Y",
    },
    {
      key: "inpatients",
      label: "In Patients",
      icon: Bed,
      route: APP_ROUTES.INPATIENTS,
      isActive: isMenuItemActive(APP_ROUTES.INPATIENTS),
      show:
        !loginResultObject || loginResultObject?.user?.himsApplicable === "Y",
    },
    {
      key: "payments",
      label: "Payments",
      icon: Wallet,
      route: APP_ROUTES.PAYMENTS,
      isActive: isMenuItemActive(APP_ROUTES.PAYMENTS),
      show: true,
    },
    {
      key: "billing",
      label: "Billing Reports",
      icon: FileText,
      route: APP_ROUTES.BILLINGREPORTS,
      isActive: isMenuItemActive(APP_ROUTES.BILLINGREPORTS),
      show: true,
    },
    {
      key: "orders",
      label: "Order Reports",
      icon: FileBarChart,
      route: APP_ROUTES.ORDERREPORT,
      isActive: isMenuItemActive(APP_ROUTES.ORDERREPORT),
      show: true,
    },
    {
      key: "referral",
      label: "Referral",
      icon: Share2,
      route: APP_ROUTES.REFERTO,
      isActive: isMenuItemActive(APP_ROUTES.REFERTO),
      show: true,
    },
    {
      key: "dietchart",
      label: "Diet Chart Config",
      icon: SlidersHorizontal,
      route: APP_ROUTES.DIETCHART,
      isActive: isMenuItemActive(APP_ROUTES.DIETCHART),
      show:
        !loginResultObject ||
        loginResultObject?.user?.dietChartApplicableYN === "Y",
    },
    {
      key: "clinic",
      label: "Mapped Clinic",
      icon: Hospital,
      route: APP_ROUTES.MAPPEDCLINICS,
      isActive: isMenuItemActive(APP_ROUTES.MAPPEDCLINICS),
      show: true,
    },
    {
      key: "settings",
      label: "Change Password",
      icon: Lock,
      route: APP_ROUTES.SETTINGS,
      isActive: isMenuItemActive(APP_ROUTES.SETTINGS),
      show: true,
    },
  ];

  return (
    <aside
      className={`h-full w-full bg-white border-l-[4px] border-[#00A896] border-r border-gray-100 flex flex-col justify-between shadow-[2px_0_12px_rgba(0,0,0,0.03)] select-none transition-all duration-300`}
    >
      {/* Alert Modal */}
      <Modal
        title="Alert"
        open={alert}
        onCancel={handleCancel}
        width={"30%"}
        footer={
          <div className="flex items-end gap-1 justify-end">
            <button
              className="mx-1 p-1 w-44 h-8 text-[#189FAA] font-semibold rounded-md bg-white border-2 border-[#979797] mt-2 hover:bg-gray-50"
              onClick={onLeave}
            >
              Leave without saving
            </button>
            <button
              className="mx-1 p-1 w-32 h-8 font-semibold text-white bg-brand-primaryColor rounded-md hover:opacity-90"
              onClick={handleCancel}
            >
              Stay on page
            </button>
          </div>
        }
      >
        You haven't saved your changes. Are you sure you want to proceed?
      </Modal>

      {/* Logout Warning Modal */}
      <Modal
        title="Logout"
        open={LogoutWarning}
        onOk={handleLogOutOk}
        onCancel={handleLogOutCancel}
        width={"22%"}
        footer={
          <div className="flex justify-end gap-2 mt-4">
            <button
              className="px-4 py-1.5 font-semibold bg-white border border-[#189FAA] text-[#189FAA] rounded-md hover:bg-gray-50"
              onClick={handleLogOutCancel}
            >
              Cancel
            </button>
            <button
              className="px-5 py-1.5 font-semibold bg-[#189FAA] text-white rounded-md hover:bg-[#14838c]"
              onClick={handleLogOutOk}
            >
              Yes
            </button>
          </div>
        }
      >
        Are you sure to log out?
      </Modal>

      {/* Top Header Section with Logo & Collapse Toggle */}
      <div className="flex-shrink-0">
        {isMenuOpen ? (
          <div className="flex items-center justify-between px-3.5 py-4 min-h-[64px] border-b border-gray-50/80">
            <div
              onClick={() => handleNavigation(APP_ROUTES.DASHBOARD)}
              className="cursor-pointer flex items-center justify-center"
              title="DOXZON"
            >
              <DoxzonClover className="w-7 h-7 flex-shrink-0" />
            </div>
            <button
              onClick={closeSidebar}
              className="w-7 h-7 rounded-full bg-white border border-gray-200 bg-white shadow-sm flex items-center justify-center text-[#0E8378] hover:bg-[#E6F8F6] hover:border-[#00A896] transition-all cursor-pointer"
              title="Collapse sidebar"
            >
              <ChevronsLeft className="w-4 h-4 text-[#0E8378]" />
            </button>
          </div>
        ) : (
          <div className="flex items-center justify-center gap-1.5 px-1 py-4 min-h-[64px] border-b border-gray-50/80">
            <div
              onClick={() => handleNavigation(APP_ROUTES.DASHBOARD)}
              className="cursor-pointer flex items-center justify-center"
              title="DOXZON"
            >
              <DoxzonClover className="w-7 h-7 flex-shrink-0" />
            </div>
            <button
              onClick={openSidebar}
              className="w-6 h-6 rounded-full bg-white border border-gray-200 bg-white shadow-sm flex items-center justify-center text-[#0E8378] hover:bg-[#E6F8F6] hover:border-[#00A896] transition-all cursor-pointer"
              title="Expand sidebar"
            >
              <ChevronsRight className="w-3.5 h-3.5 text-[#0E8378]" />
            </button>
          </div>
        )}
      </div>

      {/* Scrollable Navigation Items */}
      <div className="flex-1 overflow-y-auto px-2 py-2 space-y-1 overflow-x-hidden [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {navItems.map((item) => {
          if (!item.show) return null;
          const Icon = item.icon;

          // Special RPM Accordion / Dropdown
          if (item.isRpm) {
            if (!isMenuOpen) {
              return (
                <div
                  key={item.key}
                  className="w-full flex justify-center py-0.5"
                >
                  <Dropdown
                    menu={{ items: rpmDropdownItems }}
                    placement="bottomRight"
                    trigger={["hover", "click"]}
                  >
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-150 ${
                        item.isActive
                          ? "bg-[#E6F8F6] text-[#0E8378]"
                          : "text-[#334155] hover:bg-[#F2FAF9] hover:text-[#0E8378]"
                      }`}
                    >
                      <Icon className="w-5 h-5 flex-shrink-0" />
                    </div>
                  </Dropdown>
                </div>
              );
            }

            return (
              <div key={item.key} className="w-full">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsRpmSubMenuOpen(!isRpmSubMenuOpen);
                  }}
                  className={`group flex items-center gap-3.5 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-150 ${
                    item.isActive
                      ? "bg-[#E6F8F6] text-[#0E8378] font-semibold"
                      : "text-[#334155] hover:bg-[#F2FAF9] hover:text-[#0E8378] font-medium"
                  }`}
                >
                  <div
                    className={`flex-shrink-0 ${
                      item.isActive
                        ? "text-[#0E8378]"
                        : "text-[#334155] group-hover:text-[#0E8378]"
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <span className="text-sm truncate">{item.label}</span>
                  <ChevronDown
                    className={`w-4 h-4 ml-auto transition-transform duration-200 ${
                      isRpmSubMenuOpen
                        ? "rotate-180 text-[#0E8378]"
                        : "text-gray-400 group-hover:text-[#0E8378]"
                    }`}
                  />
                </div>

                {/* RPM Expanded Sub-menu */}
                {isRpmSubMenuOpen && (
                  <div className="pl-6 pr-1 py-1 space-y-1 transition-all">
                    {rpmSubItems.map((sub) => {
                      const isSubActive = isMenuItemActive(sub.route);
                      const SubIcon = sub.icon;
                      return (
                        <div
                          key={sub.route}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleNavigation(sub.route);
                          }}
                          className={`flex items-center gap-2.5 px-2.5 py-1.5 rounded-md text-xs cursor-pointer transition-colors ${
                            isSubActive
                              ? "bg-[#E6F8F6] text-[#0E8378] font-semibold"
                              : "text-[#475569] hover:bg-[#F2FAF9] hover:text-[#0E8378]"
                          }`}
                        >
                          <SubIcon className="w-3.5 h-3.5 flex-shrink-0" />
                          <span className="truncate">{sub.label}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }

          // Standard items
          if (!isMenuOpen) {
            return (
              <div key={item.key} className="w-full flex justify-center py-0.5">
                <Tooltip placement="right" title={item.label}>
                  <div
                    onClick={() => handleNavigation(item.route)}
                    className={`w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-150 ${
                      item.isActive
                        ? "bg-[#E6F8F6] text-[#0E8378]"
                        : "text-[#334155] hover:bg-[#F2FAF9] hover:text-[#0E8378]"
                    }`}
                  >
                    <Icon className="w-5 h-5 flex-shrink-0" />
                  </div>
                </Tooltip>
              </div>
            );
          }

          return (
            <div
              key={item.key}
              onClick={() => handleNavigation(item.route)}
              className={`group flex items-center gap-3.5 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-150 ${
                item.isActive
                  ? "bg-[#E6F8F6] text-[#0E8378] font-semibold"
                  : "text-[#334155] hover:bg-[#F2FAF9] hover:text-[#0E8378] font-medium"
              }`}
            >
              <div
                className={`flex-shrink-0 ${
                  item.isActive
                    ? "text-[#0E8378]"
                    : "text-[#334155] group-hover:text-[#0E8378]"
                }`}
              >
                <Icon className="w-5 h-5" />
              </div>
              <span className="text-sm truncate">{item.label}</span>
            </div>
          );
        })}
      </div>

      {/* Bottom Section: Divider & Logout */}
      <div className="flex-shrink-0 px-2 py-3 border-t border-gray-100">
        {isMenuOpen ? (
          <div
            onClick={() => handleLogout(APP_ROUTES.LOGINFORM)}
            className="group flex items-center gap-3.5 px-3 py-2.5 rounded-lg cursor-pointer text-[#EF4444] hover:bg-red-50 hover:text-red-600 transition-colors duration-150 font-medium"
          >
            <LogOut className="w-5 h-5 text-[#EF4444] group-hover:text-red-600 flex-shrink-0" />
            <span className="text-sm">Logout</span>
          </div>
        ) : (
          <div className="w-full flex justify-center py-0.5">
            <Tooltip placement="right" title="Logout">
              <div
                onClick={() => handleLogout(APP_ROUTES.LOGINFORM)}
                className="w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-[#EF4444] hover:bg-red-50 hover:text-red-600 transition-colors duration-150"
              >
                <LogOut className="w-5 h-5 flex-shrink-0" />
              </div>
            </Tooltip>
          </div>
        )}
      </div>
    </aside>
  );
}

export default Sidemenu;
